<template>
  <div class="container-background">
    <div>
      <div
        @click="$router.push({ name: 'Login' })"
        style="width: fit-content;"
        class="cursor-pointer display-flex align-items-center"
      >
        <v-btn
          class="button-return-icon"
          icon
        >
          <v-icon
            color="#283C4D"
            size="16px"
          >
            mdi-arrow-left
          </v-icon>
        </v-btn>
        <p class="button-return-text mon-regular hover-underline ml-2">{{ texts.passwordrecovery.textButtonReturn }}</p>
      </div>
    </div>
    <div class="display-flex align-items-center justify-content-center mt-5">
      <div
        @click="home"
        class="content-image cursor-pointer"
      >
        <img
          src="@/assets/icons/logo.png"
          alt=""
        >
      </div>
    </div>
    <div class="display-flex align-items-center justify-content-center mt-5">
      <p class="text-title mon-bold">{{ texts.passwordrecovery.textTitle }}</p>
    </div>
    <div class="display-flex align-items-center justify-content-center mb-5">
      <p class="text-description mon-regular">{{ texts.passwordrecovery.textDescription }}</p>
    </div>
    <div>
      <v-text-field
        v-model="email"
        type="email"
        :label="texts.passwordrecovery.textEmail"
        outlined
        color="#000000"
        dense
        class="global-inputs mon-regular"
        :placeholder="texts.passwordrecovery.textEmail"
        persistent-placeholder
        clearable
        maxlength="85"
      ></v-text-field>
    </div>
    <div class="display-flex align-items-center mt-5">
      <v-btn
        :loading="bLoading"
        :disabled="!validateForm"
        class="button-forgot mon-bold"
        @click="passwordRecovery"
        elevation="0"
      >
        {{ texts.passwordrecovery.textButtonForgot }}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "PasswordRecoveryFormLayout",
  props: {
    texts: {
      type: Object,
    },
  },
  data() {
    return {
      //VARIABLES
      email: "",
      bLoading: false,
    };
  },
  beforeMount() {},
  methods: {
    passwordRecovery: function () {
      this.bLoading = true;

      const payload = {
        sEmail: this.email,
      };

      DB.post(`${URI}/api/v1/${this.selectLanguage}/users/password`, payload)
        .then((response) => {
          const self = this;
          this.bLoading = false;

          this.mixSuccess(response.data.message);
          setTimeout(function () {
            self.$router
              .push({
                name: "Login",
              })
              .catch(() => {
                this.mixError(error.response.data.message, error.response.status);
              });
          }, 2500);
        })
        .catch((error) => {
          this.bLoading = false;

          this.mixError(error.response.data.message, error.response.status);
        });
    },
    home: function () {
      this.$router
        .push({
          name: "Home",
        })
        .catch(() => {});
    },
  },
  computed: {
    selectLanguage: function () {
      return this.$store.state.language;
    },
    validateForm: function () {
      return this.email !== "" && this.email !== null;
    },
  },
  watch: {},
};
</script>

<style scoped>
.text-description {
  text-align: center;
  font-size: 16px;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
}

.hover-underline:hover {
  text-decoration: underline;
}

.button-return-icon {
  background: transparent linear-gradient(258deg, #ffc556 0%, #fffc81 100%) 0%
    0% no-repeat padding-box;
  width: 25px !important;
  height: 25px !important;
}

.button-return-text {
  text-align: left;
  font-size: 18px;
  letter-spacing: 0px;
  color: #283c4d;
  opacity: 1;
  margin-bottom: 0px;
}

.button-forgot {
  height: 45px !important;
  width: 100%;
  background: transparent linear-gradient(258deg, #ffc556 0%, #fffc81 100%) 0%
    0% no-repeat padding-box;
  border-radius: 13px;
  opacity: 1;
  text-align: center;
  font-size: 14px !important;
  letter-spacing: 0px;
  color: #283c4d;
  text-transform: initial;
}

.text-title {
  text-align: center;
  font-size: 33px;
  letter-spacing: 0px;
  color: #283c4d;
  opacity: 1;
}

.container-background {
  width: 100%;
}

.content-image {
  width: 180px;
  height: 130px;
}

.content-image img {
  width: 100%;
  height: auto;
}

@supports (object-fit: contain) {
  .content-image img {
    height: 100%;
    object-fit: contain;
    object-position: center center;
  }
}

@media (max-width: 600px) {
  .text-title {
    font-size: 20px;
  }
  .text-description {
    font-size: 14px;
  }
  .button-return-text {
    font-size: 16px;
  }
}
</style>